(function () {
  var key = 'fabrecia:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }

  function write(items) {
    try { localStorage.setItem(key, JSON.stringify(items)); } catch (e) {}
    renderState();
  }

  function renderState() {
    var items = read();
    var handles = items.map(function (item) { return item.handle; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var active = handles.indexOf(button.getAttribute('data-product-handle')) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = items.length ? String(items.length) : '';
    });
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (grid) {
      grid.innerHTML = items.map(function (item) {
        return '<article class="product-card"><div class="product-card__media product-card__media--portrait"><a href="' + item.url + '"><img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></a><button class="wishlist-button icon-button is-active" data-wishlist-toggle data-product-handle="' + item.handle + '"><svg viewBox="0 0 24 24"><path fill="currentColor" d="m12 21-7.6-7.6A5.4 5.4 0 1 1 12 5.8a5.4 5.4 0 1 1 7.6 7.6L12 21Z"/></svg></button></div><div class="product-card__body"><h3 class="product-card__title"><a href="' + item.url + '">' + escapeHtml(item.title) + '</a></h3><div class="price"><span>' + escapeHtml(item.price || '') + '</span></div></div></article>';
      }).join('');
      if (empty) empty.hidden = items.length > 0;
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    var items = read();
    var handle = button.getAttribute('data-product-handle');
    var exists = items.some(function (item) { return item.handle === handle; });
    if (exists) {
      items = items.filter(function (item) { return item.handle !== handle; });
    } else {
      items.unshift({
        handle: handle,
        title: button.getAttribute('data-product-title') || handle,
        url: button.getAttribute('data-product-url') || '/products/' + handle,
        image: button.getAttribute('data-product-image') || '',
        price: button.getAttribute('data-product-price') || ''
      });
    }
    write(items.slice(0, 60));
  });

  renderState();
})();
